import { Box, Typography, useTheme, styled } from "@mui/material";
import { useTranslation } from "react-i18next";

const NoDataContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
}));

const NoDataText = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  fontSize: 14,
  whiteSpace: "nowrap",
  textAlign: "center",
}));

export const NoDataRow = () => {
  const { t } = useTranslation();

  return (
    <NoDataContainer>
      <NoDataText>{t("liveData.notStarted")}</NoDataText>
    </NoDataContainer>
  );
};
